import styles from './UserCardInfo.module.scss';
import { useTranslate } from 'react-polyglot';
import Card from '../../../Shared/Card/Card';

function UserCardInfo(props: UserCardInfoProps) {
    const t = useTranslate();

    const mainBreed = props.userBreeds?.find((b: any) => Number(b.BREED_ID) === Number(props.user?.MAIN_BREED_ID));
    const initials = [props.user?.FIRSTNAME, props.user?.LASTNAME]
        .filter(Boolean)
        .map((s: string) => s[0].toUpperCase())
        .join('') || '?';

    return (
        <div className={styles.generaloverview}>
            <div className={styles.cardwrapper}>
                <div className={styles.avatar}>
                    <span className={styles.avatarInitials}>{initials}</span>
                </div>
                <Card title={props.title || t("user.cards.generaloverview.title")}>
                    <table className={styles.infoTable}>
                        <tbody>
                            <tr>
                                <td className={styles.label}>{t("user.info.id")}</td>
                                <td className={styles.value}>{props.user?.ID}</td>
                            </tr>
                            <tr>
                                <td className={styles.label}>{t("user.info.email")}</td>
                                <td className={styles.value}>{props.user?.EMAIL}</td>
                            </tr>
                            <tr>
                                <td className={styles.label}>{t("user.info.role")}</td>
                                <td className={styles.value}>{props.user?.ROLE}</td>
                            </tr>
                            <tr>
                                <td className={styles.label}>{t("user.info.mainbreed")}</td>
                                <td className={styles.value}>{mainBreed?.BREED_NAME || '—'}</td>
                            </tr>
                        </tbody>
                    </table>
                </Card>
            </div>
        </div>
    );
}

class UserCardInfoProps {
    title?: string;
    user?: any;
    userBreeds?: Array<any>;
}

export default UserCardInfo;
